import moment from "moment";
import finalreq from "../../LifeInsurance/CreateQuote/ValidateProposer/FinalReqbody";
import getbi from "./GetBibody";

const AutoFillsetup=(data,key)=>{
   // console.log(data,key,"dataKey")
    //console.log("AutoFillregex",regex("Pilla119&,"))
    let values
    
    Object.entries(data).map((field,index)=>{
    if(values===undefined){
        const keyArray=key.split(".")
        const array=keyArray.filter((a_name,i)=> {return i!==0})
        let alteredKey
        if(keyArray.length>1){
            if(field[0]===keyArray[0]){
               values=getValue(field[1],array.join("."))

            }
            else{

                if(field[0]!==key){
                    if(Array.isArray(field[1])){
                        values=setArray(field[1],key)
                     }
                    else if(typeof field[1]==="object"){
                       
                       values= AutoFillsetup(field[1],key)
                     }
                     else{
                          
                     }
                }else{
                   values=field[1]
                }

            }
           
        }
        else{
            if(field[0]!==key){
                if(Array.isArray(field[1])){
                    values=setArray(field[1],key)
                 }
                else if(typeof field[1]==="object"){
                   
                   values= AutoFillsetup(field[1],key)
                 }
                 else{
                      
                 }
            }else{
               values=field[1]
            }
            
        }
        
        //console.log("values...",values)
     }
    
    })
   return values;
}

const setArray=(data,key)=>{
   let arrayValues;
   // console.log('setArray',data)
   data.map((item)=>{
       // console.log('item',item)
       if(typeof item==="object"){
        arrayValues=AutoFillsetup(item,key)
       }
   })
   // console.log('NEW',arrayInitialValue)
   return arrayValues
}

const getValue=(data,name)=>{
   // console.log(name,"getvalueName")
    let subData=data
    const nameArray=name.split(".")
    nameArray.map((_name)=>{
    if (_name.indexOf("[") !== -1) {
       const a_name = _name.split("[");
      
       subData = subData[`${a_name[0]}`][`${a_name[1][0]}`];
    }
    else{
        subData = subData[`${_name}`];
    }
    })

    return subData

}

/*------------------------- 3 Forms ---------------------------------------------*/

const AutoFillform=(obj1,obj2)=>{
    const values={}
    let value
    console.log('incc',obj1)
    Object.entries(obj2).map((field)=>{
       //console.log('fiel',field)
        if(field[0]==="LAName"||field[0]==="CustomerName"){
           
             value=`${AutoFillsetup(obj1,"Proposer.FirstName")} ${AutoFillsetup(obj1,"Proposer.MiddleName")} ${AutoFillsetup(obj1,"Proposer.LastName")} `
        }
        else if(field[0]==="Age"){
            
            let date=`${AutoFillsetup(obj1,"Proposer.DateofBirth")}`
            value=getAge(date)
        }
        else if(field[0]==="PayableAmount"){
            value=`${AutoFillsetup(obj1,"TotalPremium")}`
        }else if(field[0] === "Date"){
            //console.log( 'daete',moment().format("YYYY-MM-DD"))
            value = moment().format("YYYY-MM-DD")
        }else if(field[0] === "DOB"){
            //console.log( 'daete',moment().format("YYYY-MM-DD"))
            value = obj1.Request.Proposal.Proposer.DateofBirth
        }
        else{
            value=AutoFillsetup(obj1,field[0])
        }
        //console.log(value,"valueinGet")
        if(value){
            values[`${field[0]}`]=value
        }
        else{
            values[`${field[0]}`]=field[1]  
        }


})

return values
}

const AutoFillsubmit=(obj1,obj2)=>{
    
    let values
    Object.entries(obj2).map((field,index)=>{
        if(Array.isArray(field[1])){
            values=submitArray(field[1],field[0],obj1)
         }
        else if(typeof field[1]==="object"){
           
            values= submitObject(field[1],field[0],obj1)
         }
         else{
            // console.log(name,"nameInAutofill") 
            values=AutoFillsetup(obj1,field[0])  
         }

           
    })
return values
}

const submitObject=(field,name,obj1)=>{
    let values
    Object.entries(field).map((a_o_field)=>{
        if(Array.isArray(a_o_field[1])){
            values=submitArray(a_o_field[1],`${name}.${a_o_field[0]}`,obj1)
        }
        else if(typeof a_o_field[1]==="object"){
           
            values= submitObject(a_o_field[1],`${name}.${a_o_field[0]}`,obj1)
        }
         else{
            // console.log(`${name}.${a_o_field[0]}`,"nameInAutofill") 
            const array=name.split(".")
            //console.log(`${array[array.length-1]}.${a_o_field[0]}`,"*****")
            values=AutoFillsetup(obj1,`${array[array.length-1]}.${a_o_field[0]}`)
         }

    })
    return name
}

const submitArray=(field,name,obj1)=>{
    let values
    field.map((a_field,index)=>{
        Object.entries(a_field,index).map((a_o_field)=>{
            if(Array.isArray(a_o_field[1])){
                values=submitArray(a_o_field[1],`${name}[${index}].${a_o_field[0]}`,obj1)
             }
            else if(typeof a_o_field[1]==="object"){
               
                values= submitObject(a_o_field[1],`${name}[${index}].${a_o_field[0]}`,obj1)
             }
             else{
                // console.log(`${name}.${a_o_field[0]}`,"nameInAutofill")
                const array=name.split(".")
                values=AutoFillsetup(obj1,`${array[array.length-1]}.${a_o_field[0]}`)
             }
     return values
        })


    })
    
}



/*------------------------- 3 Forms ---------------------------------------------*/


const regex=(address)=>{
    // new RegExp(/^[1-9][0-9]*$/).test(number)
    // new RegExp(/[#.0-9a-zA-Z\s,-]+$/).test(address)
    
    return new RegExp(/^[#.&/0-9a-zA-Z\s,-]+$/).test(address)
}

const getAge=(date)=>{
    const getAgee = Math.floor((new Date() - new Date(date).getTime()) / 3.15576e+10)
    console.log('age',getAgee)
    return getAgee
}




export default AutoFillform


